export const MenuListArray2 = [

    {
        title: 'Home',
        to: '/',
    },
    {
        title: 'Shop',
        // title: 'Explore Gifts',
        to: '/shop',
    },
    {
        title: 'Students',
        // title: 'Student Creations',
        to: '/student-list',
    },
    {
        title: 'Our Story',
        to: '/about-us',
    },
    {
        title: 'Impact',
        to: '/impact',
    },
    {
        title: 'Artist Stories',
        to: '/artist-stories',
    },


    // {
    //     title: 'Contact Us',
    //     to: '/contact-us',
    // },


    // {
    //     title: 'Explore Rakhis',
    //     to: '/handmade-rakhi-online',
    // },


    {
        title: 'Explore DIY Kits',
        to: '/diy-products',
    },


    {
        title: "Sell Your Art",
        to: 'https://arttokri.com/student_panel/register',
    }
]
